import BodyOne from '@/components/portal/ui/typography/BodyOne'
import HeadingTwo from '@/components/portal/ui/typography/HeadingTwo'
import React from 'react'

interface RegisterHeaderProps {
  confirmation?: boolean
}

const RegisterHeader: React.FC<RegisterHeaderProps> = ({ confirmation }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <HeadingTwo
        fontSize="text-2xl"
        additionalClasses="text-center"
        fontWeight="font-ttHovesBold"
        color="text-green-classic"
      >
        {confirmation
          ? 'Check your inbox'
          : 'Welcome to the NPT customer portal.'}
      </HeadingTwo>
      {confirmation && (
        <BodyOne additionalClasses="mb-8" fontSize="text-regular">
          We sent you an authorization link. Please be sure to check your spam
          folder.
        </BodyOne>
      )}
    </div>
  )
}

export default RegisterHeader
